<app-generic-container>


    <!-- Usamos el panel genérico -->
    <app-generic-panel [title]="panelTitle" [description]="panelDescription" [awesomeIcon]="panelIcon">
        <div class="how-button-container">
            <button class="btn btn-fill btn-primary how-button" type="button" (click)="openPDF()">
                <i class="material-icons">
                    lightbulb_outline </i>
                ¿CÓMO FUNCIONA?
            </button>
        </div>
        <div class="col-12 mt-4 row">
            <!-- <div class="col-3">
                <app-dropdown-formularios dataSize="7" placeHolder="Vista" [selectedValue]="view"
                    (selectedValueChange)="viewSelectedChanged($event)" [required]="true" [disabled]="false"
                    [dropdownType]="'AttendanceView'" detailedData="true">
                </app-dropdown-formularios>
            </div> -->
            <div class="col-3">
                <app-dropdown-formularios dataSize="7" placeHolder="Empresa" [selectedValue]="company"
                    (selectedValueChange)="companySelectedChanged($event)" [required]="false" [disabled]="false"
                    [dropdownType]="'Companies'" detailedData="true" [emptyOption]="true">
                </app-dropdown-formularios>
            </div>
            <div class="col-3" *ngIf="conectiaLicence">
                <app-dropdown-formularios dataSize="7" placeHolder="Centro de coste" [selectedValue]="filterCostCenter"
                    (selectedValueChange)="costCenterSelectedChanged($event)" [required]="false" [disabled]="false"
                    [dropdownType]="'CostCenters'" detailedData="true" [emptyOption]="true">
                </app-dropdown-formularios>
            </div>
            <div class=" d-inline-flex align-items-end mb-2 pb-1 justify-content-start w-auto">
                <legend class="azul-a3Factura m-0 mr-3 w-auto date-input-label">Desde</legend>
                <dx-date-box id="dateStart" type="date" [value]="filterStart" [max]="filterEnd || maxDate"
                    [displayFormat]="'dd/MM/yyyy'"
                    [inputAttr]="{ 'aria-label': 'Desde', 'style': 'padding: 5px !important; font-size: 13px !important;' }"
                    style="max-height: 2.8em; width: 100%; background: transparent !important; margin-bottom: 0.4em"
                    (onValueChanged)="onDateStartChange($event)">
                </dx-date-box>
            </div>

            <div class=" d-inline-flex align-items-end mb-2 pb-1 justify-content-start w-auto">
                <legend class="azul-a3Factura m-0 mr-3 w-auto  date-input-label">Hasta</legend>
                <dx-date-box id="dateEnd" type="date" [value]="filterEnd" [max]="maxDate" [min]="filterStart"
                    [displayFormat]="'dd/MM/yyyy'"
                    [inputAttr]="{ 'aria-label': 'Hasta', 'style': 'padding: 5px !important; font-size: 13px !important;' }"
                    style="max-height: 2.8em; width: 100%; background: transparent !important; margin-bottom: 0.4em"
                    (onValueChanged)="onDateEndChange($event)">
                </dx-date-box>
            </div>
            <button class="btn btn-primary btn-sm btn-add ml-4" style=" max-height: 3em; " (click)="onResetFilters()">
                <i class="material-icons">repeat</i>
                <span class="d-none d-sm-inline-block ml-2">Limpiar filtros</span>
            </button>
        </div>
        <mat-tab-group (selectedIndexChange)="onTabChange($event)" style="overflow-y: auto;">
            <mat-tab label="Vista por día">
                <dx-data-grid #dataGrid0 id="gridContainer0" [dataSource]="dataSource0"
                    (onRowPrepared)="onRowPrepared0($event)" (onExporting)="onExporting0($event)"
                    (onToolbarPreparing)="onToolbarPreparing($event)">

                    <!-- Definición de las columnas -->
                    <dxi-column dataField="valid" caption="Estado" alignment="center" [allowFiltering]="false"
                        cellTemplate="statusTemplate">
                    </dxi-column>
                    <dxi-column dataField="day" caption="Día" dataType="date" alignment="center" format="dd/MM/yyyy"
                        [allowFiltering]="false" [sortOrder]="'desc'"
                        [calculateCellValue]="adjustAttendanceSummaryDate"></dxi-column>
                    <dxi-column dataField="companyData.name" caption="Empresa" alignment="center"></dxi-column>
                    <dxi-column dataField="userData.fullName" caption="Empleado" alignment="center"></dxi-column>
                    <dxi-column dataField="firstEntryTime" caption="Primera entrada" dataType="date" alignment="center"
                        format="HH:mm" [allowFiltering]="false" cellTemplate="firstEntryTemplate"></dxi-column>
                    <dxi-column dataField="firstTypeData.name" caption="Tipo entrada" alignment="center"></dxi-column>
                    <dxi-column dataField="lastExitTime" caption="Última salida" dataType="date" alignment="center"
                        format="HH:mm" [allowFiltering]="false" cellTemplate="lastExiTemplate"></dxi-column>
                    <dxi-column dataField="lastTypeData.name" caption="Tipo salida" alignment="center"
                        cellTemplate="lastTypeTemplate">
                    </dxi-column>
                    <dxi-column dataField="totalHours" caption="Total Horas" alignment="center"
                        [calculateCellValue]="formatTimeValue"></dxi-column>


                    <!-- Templates -->

                    <ng-container *dxTemplate="let data of 'statusTemplate'">
                        <div class="status-container" [ngStyle]="{'background-color': getStatusColor(data.data.valid)}"
                            [matTooltip]="data.data.valid ? 'Válido' : getInvalidSummaryTooltip(data.data.invalidSummaryDayReasons)">
                            <fa-icon [icon]="getIconForStatus(data.data.valid)" style="margin-top: 1px;"></fa-icon>
                        </div>
                    </ng-container>

                    <ng-container *dxTemplate="let data of 'lastExiTemplate'">
                        <span style="cursor: pointer;" [matTooltip]="data.data.lastExitLocalTimeZone ?? ''">
                            {{ adjustAttendanceSummaryLastExitTime(data.data) }}
                        </span>
                    </ng-container>

                    <ng-container *dxTemplate="let data of 'lastTypeTemplate'">
                        <span style="cursor: pointer;" [matTooltip]="data.data.lastExitLocalTimeZone ?? ''">
                            <ng-container *ngIf="data.data.lastTypeData?.imputable">
                                {{ data.data.lastTypeData.name + ' (suma jornada)' }}
                            </ng-container>
                            <ng-container *ngIf="!data.data.lastTypeData?.imputable">
                                {{ data.data.lastTypeData?.name }}
                            </ng-container>
                        </span>
                    </ng-container>




                    <ng-container *dxTemplate="let data of 'firstEntryTemplate'">
                        <span style="cursor: pointer;" [matTooltip]="data.data.firstEntryLocalTimeZone ?? ''">
                            {{ adjustAttendanceSummaryFirstEntryTime(data.data) }}
                        </span>
                    </ng-container>

                    <ng-container>
                        <dxi-column dataField="attendanceRecord1" caption="Acciones" [allowFiltering]="false"
                            [allowSorting]="false" alignment="center" cellTemplate="buttonCRUDTemplate"
                            [allowExporting]="false"></dxi-column>
                        <ng-container *dxTemplate="let data of 'buttonCRUDTemplate'">
                            <button rel="tooltip" type="button" class="btn btn-action btn-primary"
                                (click)="onClickCheck0(data.data)" matTooltip="Ver detalles">
                                <i class="material-icons">remove_red_eye</i>
                            </button>
                        </ng-container>
                    </ng-container>

                    <dxo-export [enabled]="true" [fileName]="generateExportFileName0()"></dxo-export>


                </dx-data-grid>
            </mat-tab>
            <mat-tab label="Vista por registro">
                <dx-data-grid #dataGrid1 id="gridContainer1" [dataSource]="dataSource1"
                    (onRowPrepared)="onRowPrepared1($event)" (onExporting)="onExporting1($event)"
                    (onToolbarPreparing)="onToolbarPreparing($event)">

                    <!-- Definición de las columnas -->

                    <dxi-column dataField="attendanceAt" [visible]="false" [sortOrder]="'desc'"
                        [showInColumnChooser]="false" sortIndex="0"><!-- Columna oculta para ordenar -->
                    </dxi-column>

                    <dxi-column dataField="valid" caption="Estado" alignment="center" [allowFiltering]="false"
                        cellTemplate="statusTemplate">
                    </dxi-column>
                    <dxi-column dataField="attendanceAt" caption="Día" dataType="date" alignment="center"
                        format="dd/MM/yyyy" [allowFiltering]="false"
                        [calculateCellValue]="adjustAttendanceDate"></dxi-column>
                    <dxi-column dataField="companyData.name" caption="Empresa" alignment="center"></dxi-column>
                    <dxi-column dataField="userData.fullName" caption="Empleado" alignment="center"></dxi-column>
                    <dxi-column dataField="attendanceAt" caption="Hora de marcaje local" dataType="date"
                        alignment="center" format="HH:mm" [allowFiltering]="false"
                        cellTemplate="attendanceHourTemplate"></dxi-column>
                    <dxi-column dataField="typeData.name" caption="Tipo" alignment="center"
                        cellTemplate="typeTemplate"></dxi-column>
                    <dxi-column dataField="source" caption="Origen" alignment="center" cellTemplate="sourceTemplate"
                        [calculateCellValue]="formatSource"></dxi-column>
                    <dxi-column dataField="workCenterData.name" caption="Centro" alignment="center"></dxi-column>
                    <dxi-column dataField="coordinates" caption="Localización" alignment="center"
                        [calculateCellValue]="formatCoordinates" cellTemplate="coordinatesTemplate"></dxi-column>

                    <!-- Templates -->

                    <ng-container *dxTemplate="let data of 'statusTemplate'">
                        <div class="status-container" [ngStyle]="{'background-color': getStatusColor(data.data.valid)}"
                            [matTooltip]="data.data.valid ? 'Válido' : getInvalidRecordTooltip(data.data.invalidReason)">
                            <fa-icon [icon]="getIconForStatus(data.data.valid)" style=" margin-top: 1px;"></fa-icon>
                        </div>
                    </ng-container>

                    <ng-container *dxTemplate="let data of 'sourceTemplate'">
                        <div class="source-container" [matTooltip]="data.data.source === 'APP' ? 'APP' : 'MANUAL'">
                            <fa-icon [icon]="getIconForSource(data.data.source)" style=" margin-top: 1px;"></fa-icon>
                        </div>
                    </ng-container>

                    <ng-container *dxTemplate="let data of 'attendanceHourTemplate'">
                        <span style="cursor: pointer;" [matTooltip]="data.data.timeZone ?? ''">
                            {{ adjustAttendanceTime(data.data) }}
                        </span>
                    </ng-container>

                    <ng-container *dxTemplate="let data of 'typeTemplate'">
                        <span style="cursor: pointer;" [matTooltip]="data.data.lastExitLocalTimeZone ?? ''">
                            <ng-container *ngIf="data.data.typeData?.entry === false">
                                {{ data.data.typeData?.name }}
                                <ng-container *ngIf="data.data.typeData?.imputable">
                                    (suma jornada)
                                </ng-container>
                            </ng-container>
                            <ng-container *ngIf="data.data.typeData?.entry !== false">
                                {{ data.data.typeData?.name }}
                            </ng-container>
                        </span>
                    </ng-container>



                    <ng-container *dxTemplate="let data of 'coordinatesTemplate'">
                        <span *ngIf="data.data.coordinates" style="cursor: pointer;text-decoration: underline;"
                            (click)="onLocationCheck(data.data)">
                            {{ data.data.coordinates }}
                        </span>
                        <span *ngIf="!data.data.coordinates">
                            Sin localización
                        </span>
                    </ng-container>

                    <ng-container>
                        <dxi-column dataField="attendanceRecord1" caption="Acciones" [allowFiltering]="false"
                            [allowSorting]="false" alignment="center" cellTemplate="buttonCRUDTemplate"
                            [allowExporting]="false"></dxi-column>
                        <ng-container *dxTemplate="let data of 'buttonCRUDTemplate'">
                            <button rel="tooltip" type="button" class="btn btn-action btn-primary"
                                (click)="onClickToggleValid1(data)"
                                [matTooltip]="data.data.valid ? 'Marcar como no válido' : 'Marcar como válido'">
                                <i class="material-icons">
                                    {{ data.data.valid ? 'block' : 'check' }}
                                </i>
                            </button>
                            <button rel="tooltip" type="button" class="btn btn-action btn-primary"
                                (click)="onClickCheck1(data.data)" matTooltip="Ver detalles">
                                <i class="material-icons">remove_red_eye</i>
                            </button>

                            <button rel="tooltip" type="button" class="btn btn-action"
                                [ngClass]="data.data.enabled ? 'btn-primary' : 'btn-default'"
                                (click)="onClickToggleEnable1(data)">
                                <ng-container *ngIf="data.data.enabled; else disabledIcon">
                                    <i class="material-icons" matTooltip="Deshablitar">toggle_on</i>
                                </ng-container>
                                <ng-template #disabledIcon>
                                    <i class="material-icons" matTooltip="Habilitar">toggle_off</i>
                                </ng-template>
                            </button>

                        </ng-container>
                    </ng-container>

                    <!-- Añadir nuevos -->
                    <div *dxTemplate="let data of 'addNew'">
                        <button class="btn btn-primary btn-sm btn-add" (click)="onClickAdd1()">
                            <i class="material-icons">add</i>
                            <span class="d-none d-sm-inline-block">Nuevo</span>
                        </button>
                    </div>

                    <dxo-export [enabled]="true" [fileName]="generateExportFileName1()"></dxo-export>
                </dx-data-grid>
            </mat-tab>

        </mat-tab-group>
    </app-generic-panel>

    <br>
</app-generic-container>